import { useFileQuery } from '../useFileQuery'
import { usePostQuery } from '../usePostQuery'

export const useAssignAsset = () => {
  const { post, isFetching } = useFileQuery({ url: '/assign/asset' })
  return { assignAsset: post, isFetching }
}

export const useDestroyAsset = () => {
  const { post, isFetching } = usePostQuery({ url: '/assets', method: 'DELETE' })
  return { destroyAsset: post, isFetching }
}
